import { Component, Injector, OnInit, OnChanges } from '@angular/core';
import { ClBaseComponent } from '../cl-base/cl-base.component';
import { FormStatusEnum } from 'src/app/common/enumerations/enumerations';
import { PlaceholdersService } from 'src/app/services/placeholders/placeholders.service';

@Component({
  selector: 'cl-radio-placeholder-cond',
  templateUrl: './cl-radio-placeholder-cond.component.html',
  styleUrls: ['./cl-radio-placeholder-cond.component.scss']
})
export class ClRadioPlaceholderCondComponent extends ClBaseComponent implements OnInit {

  constructor(
    protected override injector: Injector,
    private placeholderService: PlaceholdersService
  ) {
    super(injector);
  }

  /**
   * Evaluates placeholder conditions while preserving completed selections during ordinary refreshes.
   */
  ngOnInit() {
    if (!this.editor && !this.builder && this.checklist?.checklistStatus?.formStatusID != FormStatusEnum.Canceled) {
      this.placeholderService.keyValuePairsObservable.subscribe(data => {
        // Keep the completed selection stable during incoming-monitor and checklist refreshes.
        if (this.checked && this.radioSelection && !this.placeholderService.recalculateRadMonitorConditions) this.setValues();
        else this.placeHolderSelection();
      });
    }
  }

  setValues() {
    const configuration = this.utils.JSONparse(this.configuration);
    this.radioOptions?.map(o => o.checked = o.id == this.radioSelection);
  }

  /**
   * Derives the radio and checkbox state from the configured numeric placeholder.
   */
  placeHolderSelection() {
    const configuration = this.utils.JSONparse(this.configuration);
    const placeholder = configuration?.placeholder;
    const value = this.placeholderService.getValue(placeholder);
    if (!isNaN(value) && value !== null && value !== '') {
      this.radioOptions?.map(o => {
        if (o.operator) {
          const result = this.utils.compareNumbers(value, o.value, o.operator);
          if (result && o.id != this.radioSelection) {
            this.radioSelected.emit(o.id);
          }
          o.checked = result;
        }
      });

      const hasSelection = !this.unselected();
      if (this.checked != hasSelection) {
        this.checked = hasSelection;
        if (this.getCurrentUser()) {
          this.answered.emit(this.checked);
        }
      }
    }
    else {
      this.radioOptions?.map(o => o.checked = false);
      if (this.checked) {
        this.checked = false;
        if (this.getCurrentUser()) {
          this.answered.emit(false);
        }
      }
    }
  }

  /**
   * Applies a checkbox change only when one radio option is selected.
   * @param e - Checkbox event containing the requested checked state.
   */
  checkboxChanged(e: any) {
    // Never allow the task checkbox to complete without a derived or user-selected radio option.
    if (e.checked && this.unselected()) {
      e.source.checked = false;
      return;
    }
    this.checked = e.checked;
    this.answered.emit(this.checked);
  }

  radioChange(e: any) {
    this.radioSelected.emit(e.id);
    this.radioSelection = e.id;
    this.checked = true;
    this.radioOptions?.map(x => x.checked = x.id == this.radioSelection);
  }

  unselected() {
    return !this.radioOptions?.map(r => r.checked).includes(true);
  }

  setRadio(value: any) {
    this.radioOptions?.map(r => {
      r.checked = r.value == value;
    });
  }

}
